import { createContext } from 'use-context-selector';
import { FormChangesDto } from 'src/services/api/api-client';

export interface FormHistoryContextInterface {
  selectedVersion?: FormChangesDto;
  previousVersionOfSelectedVersion?: FormChangesDto;
}

const defaultValues: Partial<FormHistoryContextInterface> = {
  selectedVersion: undefined,
  previousVersionOfSelectedVersion: undefined,
};

export const FormHistoryContext = createContext(defaultValues);
